"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.motion = exports.focusRing = exports.elevations = void 0;
var _primitives = require("./primitives");
/**
 * Motion tokens — one timing vocabulary for MUI transitions and shared
 * components so the product animates consistently.
 */
const motion = exports.motion = {
  duration: {
    fast: 120,
    base: 200,
    slow: 300
  },
  easing: {
    standard: 'cubic-bezier(0.4, 0, 0.2, 1)',
    decelerate: 'cubic-bezier(0, 0, 0.2, 1)',
    accelerate: 'cubic-bezier(0.4, 0, 1, 1)'
  }
};

/**
 * Keyboard focus ring per mode. Applied via the web MUI theme and shared
 * components so focus visibility is a token decision, not per-component.
 */
const focusRing = exports.focusRing = {
  dark: {
    width: 2,
    offset: 2,
    color: _primitives.brand.cyan
  },
  light: {
    width: 2,
    offset: 2,
    color: _primitives.brand.cyanDeep
  }
};

/**
 * Elevation strategy:
 *  - dark mode separates surfaces with borders/overlays, so shadows stay
 *    minimal (depth cues only on modals/popovers);
 *  - light mode relies on layered soft navy-tinted shadows instead of borders.
 */
const elevations = exports.elevations = {
  dark: {
    e0: {
      boxShadow: 'none',
      native: {
        shadowColor: '#000000',
        shadowOpacity: 0,
        shadowRadius: 0,
        shadowOffset: {
          width: 0,
          height: 0
        },
        elevation: 0
      }
    },
    e1: {
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.30)',
      native: {
        shadowColor: '#000000',
        shadowOpacity: 0.3,
        shadowRadius: 2,
        shadowOffset: {
          width: 0,
          height: 1
        },
        elevation: 1
      }
    },
    e2: {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.35)',
      native: {
        shadowColor: '#000000',
        shadowOpacity: 0.35,
        shadowRadius: 6,
        shadowOffset: {
          width: 0,
          height: 4
        },
        elevation: 4
      }
    },
    e3: {
      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.45)',
      native: {
        shadowColor: '#000000',
        shadowOpacity: 0.45,
        shadowRadius: 16,
        shadowOffset: {
          width: 0,
          height: 12
        },
        elevation: 12
      }
    }
  },
  light: {
    e0: {
      boxShadow: 'none',
      native: {
        shadowColor: '#0B1623',
        shadowOpacity: 0,
        shadowRadius: 0,
        shadowOffset: {
          width: 0,
          height: 0
        },
        elevation: 0
      }
    },
    e1: {
      boxShadow: '0 1px 2px rgba(11, 22, 35, 0.06), 0 1px 3px rgba(11, 22, 35, 0.10)',
      native: {
        shadowColor: '#0B1623',
        shadowOpacity: 0.1,
        shadowRadius: 2,
        shadowOffset: {
          width: 0,
          height: 1
        },
        elevation: 1
      }
    },
    e2: {
      boxShadow: '0 4px 12px rgba(11, 22, 35, 0.10), 0 2px 4px rgba(11, 22, 35, 0.06)',
      native: {
        shadowColor: '#0B1623',
        shadowOpacity: 0.12,
        shadowRadius: 6,
        shadowOffset: {
          width: 0,
          height: 4
        },
        elevation: 4
      }
    },
    e3: {
      boxShadow: '0 12px 32px rgba(11, 22, 35, 0.14), 0 4px 8px rgba(11, 22, 35, 0.06)',
      native: {
        shadowColor: '#0B1623',
        shadowOpacity: 0.16,
        shadowRadius: 16,
        shadowOffset: {
          width: 0,
          height: 12
        },
        elevation: 12
      }
    }
  }
};